export const ORGANISATIONS = [
  {
    id: "1",
    name: "OSS Cameroon",
    description:
      "Describe your organisation here r sit amet,  nsectetur adipiscing elit. ipsum dolor sit amet... stil continues here",
    membersCount: 345,
    logo: "/assets/fixtures/organisations/oss.svg",
    banner: "/assets/fixtures/organisations/banner.svg",
  },
  {
    id: "1",
    name: "OSS Cameroon",
    description:
      "Describe your organisation here r sit amet,  nsectetur adipiscing elit. ipsum dolor sit amet... stil continues here",
    membersCount: 345,
    logo: "/assets/fixtures/organisations/oss.svg",
    banner: "/assets/fixtures/organisations/banner.svg",
  },
  {
    id: "1",
    name: "OSS Cameroon",
    description:
      "Describe your organisation here r sit amet,  nsectetur adipiscing elit. ipsum dolor sit amet... stil continues here",
    membersCount: 345,
    logo: "/assets/fixtures/organisations/oss.svg",
    banner: "/assets/fixtures/organisations/banner.svg",
  },
  {
    id: "1",
    name: "OSS Cameroon",
    description:
      "Describe your organisation here r sit amet,  nsectetur adipiscing elit. ipsum dolor sit amet... stil continues here",
    membersCount: 345,
    logo: "/assets/fixtures/organisations/oss.svg",
    banner: "/assets/fixtures/organisations/banner.svg",
  },
  {
    id: "1",
    name: "OSS Cameroon",
    description:
      "Describe your organisation here r sit amet,  nsectetur adipiscing elit. ipsum dolor sit amet... stil continues here",
    membersCount: 345,
    logo: "/assets/fixtures/organisations/oss.svg",
    banner: "/assets/fixtures/organisations/banner.svg",
  },
  {
    id: "1",
    name: "OSS Cameroon",
    description:
      "Describe your organisation here r sit amet,  nsectetur adipiscing elit. ipsum dolor sit amet... stil continues here",
    membersCount: 345,
    logo: "/assets/fixtures/organisations/oss.svg",
    banner: "/assets/fixtures/organisations/banner.svg",
  },
];
